// src/components/dashboard/charts/usePlotlyAutoResize.js
import { useEffect, useRef } from "react";

export function usePlotlyAutoResize() {
  const plotDivRef = useRef(null);   // div interno de plotly
  const wrapperRef = useRef(null);   // contenedor que cambia de tamaño

  useEffect(() => {
    if (!wrapperRef.current) return;

    const ro = new ResizeObserver(() => {
      // Plotly expone resize en el div (gd). react-plotly lo monta dentro.
      const gd = plotDivRef.current;
      if (gd && window.Plotly?.Plots?.resize) {
        window.Plotly.Plots.resize(gd);
      }
    });

    ro.observe(wrapperRef.current);
    return () => ro.disconnect();
  }, []);

  return { wrapperRef, plotDivRef };
}